import { render, staticRenderFns } from "./ValidatedTelephoneField.vue?vue&type=template&id=56ac137d&"
import script from "./ValidatedTelephoneField.vue?vue&type=script&lang=js&"
export * from "./ValidatedTelephoneField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports